export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极致流畅',
    description: '采用新一代视频编码技术，加载速度提升300%，拖动进度条零延迟，带来丝滑的观看体验。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '一键下载',
    description: '支持高清视频一键下载，离线也能随心看。智能压缩技术确保高清画质同时节省存储空间。',
  },
  {
    icon: 'ri-robot-2-line',
    title: '智能推荐',
    description: '基于深度学习的推荐算法，越用越懂你。精准捕捉你的喜好，让每一秒都看到想看的内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    description: '严格的内容审核机制，杜绝不良信息。纯净的社区氛围，让每一次浏览都安心舒适。',
  },
];

export const stats = [
  { value: '5000万+', label: '累计用户' },
  { value: '200万+', label: '日活用户' },
  { value: '1000万+', label: '视频总量' },
  { value: '99.9%', label: '服务可用率' },
];

export const testimonials = [
  {
    name: '王小明',
    role: '大学生',
    content: '小蓝视频真的太适合碎片时间了！等公交、排队的时候刷几个视频，推荐的内容都是我喜欢的，一刷就停不下来。',
    rating: 5,
  },
  {
    name: '李婷婷',
    role: '上班族',
    content: '每天通勤路上必刷小蓝视频，下载功能太方便了，地铁里信号不好也能看。内容质量比其他平台高很多！',
    rating: 5,
  },
  {
    name: '张伟',
    role: '自由职业者',
    content: '作为一个美食博主，小蓝视频给了我很多创作灵感。社区氛围很好，用户的评论也都很友善。',
    rating: 5,
  },
  {
    name: '陈思思',
    role: '设计师',
    content: '界面设计简洁清爽，没有乱七八糟的广告。视频画质清晰，加载速度也很快，体验感一流。',
    rating: 4,
  },
];

export const teamMembers = [
  {
    name: '蓝海',
    role: '创始人 & CEO',
    description: '前字节跳动高级产品经理，10年互联网产品经验，对短视频行业有深刻洞察。',
  },
  {
    name: '林悦',
    role: '联合创始人 & CTO',
    description: '前阿里巴巴技术专家，专注视频编解码与推荐算法研究，拥有多项技术专利。',
  },
  {
    name: '赵一鸣',
    role: '内容运营总监',
    description: '前快手内容运营负责人，擅长内容生态建设与创作者运营，打造优质内容社区。',
  },
];

export const brandStory = {
  title: '我们的故事',
  paragraphs: [
    '小蓝视频诞生于2024年，由一群热爱视频创作的年轻人发起。我们注意到，市面上很多短视频平台要么内容质量参差不齐，要么充斥着过多的广告和商业推广，用户的观看体验大打折扣。',
    '于是，我们决定打造一款真正以用户体验为核心的短视频平台——小蓝视频。我们把"轻量、高清、流畅"作为产品的核心基因，致力于让每一个碎片时间都变得更有价值。',
    '经过两年的发展，小蓝视频已经积累了超过5000万用户，平台上汇聚了来自各行各业的优质创作者。从搞笑段子到硬核科普，从美食探店到旅行记录，从音乐翻唱到萌宠日常，你可以在这里找到任何你感兴趣的内容。',
    '未来，我们将继续坚持"内容为王、技术驱动"的理念，不断优化推荐算法，扶持优质创作者，让更多人通过小蓝视频发现世界的精彩。',
  ],
};

export const contactInfo = {
  email: 'support@xiaolanvideo.com',
  phone: '400-888-6666',
  address: '深圳市南山区科技园南路88号蓝海大厦15层',
  wechat: 'xiaolan_video',
  workHours: '周一至周五 9:00-18:00',
};